import { Link, LinkProps } from 'react-router-dom';

import * as Styled from './ActionLink.styles';

const ActionLink = ({ to, ...props }: Partial<LinkProps>) => {
  const component = to ? Link : 'a';

  return <Styled.ActionLink as={component} to={to} {...props} />;
};

export default ActionLink;
